export default "__VITE_ASSET__C5p1DAfr__"